import { Button, Skeleton } from '@heroui/react';
import { ShoppingBag } from 'iconsax-react';

export type ProductActionProps = {
  size?: 'sm' | 'lg';
  isSelected?: boolean;
  isLoading?: boolean;
  isIcon?: boolean;
  onPress?: () => void;
};

export const ProductAction = ({
  isSelected = false,
  isIcon = false,
  isLoading = false,
  onPress,
  size = 'sm',
}: ProductActionProps) => {
  if (isIcon) {
    return (
      <Skeleton className="rounded-md" isLoaded={!isLoading}>
        <Button
          variant="solid"
          radius="lg"
          color="primary"
          size={size}
          isIconOnly
          startContent={
            <ShoppingBag
              className="select-none border-none outline-none"
              color="#ffffff"
              size={size === 'lg' ? '20' : '16'}
              variant="Outline"
            />
          }
          onPress={onPress}
        />
      </Skeleton>
    );
  }

  if (isSelected) {
    return (
      <Skeleton className="rounded-md flex-grow" isLoaded={!isLoading}>
        <Button
          variant="solid"
          radius="lg"
          size={size}
          className="lg:h-12 lg:text-base lg:font-medium"
          color="primary"
          fullWidth
          startContent={
            <ShoppingBag
              className="select-none border-none outline-none"
              color="#ffffff"
              size={size === 'lg' ? '20' : '16'}
              variant="Outline"
            />
          }
          onPress={onPress}
        >
          В корзину
        </Button>
      </Skeleton>
    );
  }

  return (
    <Skeleton className="rounded-md flex-grow" isLoaded={!isLoading}>
      <Button
        variant="bordered"
        radius="lg"
        fullWidth
        className="lg:h-12 lg:text-base lg:font-medium"
        size={size}
        startContent={
          <ShoppingBag
            className="select-none border-none outline-none"
            color="#1A73E8"
            size={size === 'lg' ? '20' : '16'}
            variant="Outline"
          />
        }
        onPress={onPress}
      >
        В корзину
      </Button>
    </Skeleton>
  );
};
